import { CSSProperties } from "react";
import clsx from "clsx";
import { Slider } from "@radix-ui/themes";

type Props = {
  value: number;
  values: number[];
  min: number;
  max: number;
  step: number;
  className?: string;
  classNameSlider?: string;
  classNameLabel?: string;
  onChange: (value: number) => void;
};

export default function GasStationFuelAmountSlider({
  value,
  values,
  min,
  max,
  step,
  className,
  classNameSlider,
  classNameLabel,
  onChange,
}: Props) {
  const width = 100 / (values.length - 1);

  return (
    <div className={clsx("flex flex-col w-full", className)}>
      <Slider
        variant="soft"
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(v: number[]) => {
          const newValue = v[0];
          onChange(newValue);
        }}
        className={clsx("cursor-pointer", classNameSlider)}
        style={{ "--custom-color": "var(--accent-solid)" } as CSSProperties}
      />
      <div className={clsx("flex items-center")}>
        {values.map((v, index) => {
          const isEdges = index === 0 || index === values.length - 1;
          return (
            <div
              key={v}
              className={clsx(
                "flex flex-col gap-1.5 cursor-pointer mt-1.5 text-11 font-bold",
                {
                  "items-start": index === 0,
                  "items-end": index === values.length - 1,
                  "items-center": !isEdges,
                },
                classNameLabel,
              )}
              style={{
                width: isEdges ? `${width / 2}%` : `${width}%`,
              }}
            >
              <div className="h-[0.375rem] w-[1px] bg-white/10" />
              {v}
            </div>
          );
        })}
      </div>
    </div>
  );
}
